import { render, staticRenderFns } from "./BackUp.vue?vue&type=template&id=ea957820&scoped=true&"
import script from "./BackUp.vue?vue&type=script&lang=js&"
export * from "./BackUp.vue?vue&type=script&lang=js&"
import style0 from "./BackUp.vue?vue&type=style&index=0&id=ea957820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea957820",
  null
  
)

export default component.exports